module.exports = __webpack_public_path__ + "img/wrong@2x.88be6226.png";